import React from 'react';

interface Statement {
   id: number;
   excerpt: string;
   date: string;
   url: string;
   flagged: boolean;
}

interface RepSidebarProps {
   statements: Statement[];
}

// Statements are still mocked upstream, so this stays a placeholder until real data lands.
const RepSidebar: React.FC<RepSidebarProps> = () => (
   <aside className="card">
      <p className="eyebrow mb-3">Recent statements</p>
      <p className="font-display text-2xl text-bone-muted">Coming soon.</p>
      <p className="mt-3 text-sm text-bone-dim">
         Floor speeches and public statements, cross-checked against the voting record.
      </p>
   </aside>
);

export default RepSidebar;
